import {I_ACCESS_TOKEN_PARAMS,_customFetch, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- PLANIFICATION
// ---------------------------------

const ENDPOINT_PLANIFICATION = '/planification';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  from_date: string;  // format yyyy-mm-dd
  to_date: string;
  activity_types: string;
  directions: string;
  hubs: string;
  skills: string;
  functions: string;
  collaborators: string;
  audited_customers: string;
  referentials: string;
  referential_types: string;
  of_number: string;
  postpone?: string;
}
/**
 * Requete le endpoint planification totals
 * Récupère les totaux pour les keycards
 * @param param0
 */
const getTotals = async ({
  accessToken,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - getPlanificationTotalsResponse - ...'));
  const options = getFetchGETOptions({accessToken});
  const paramFrom = from_date !== undefined ? `from_date=${from_date}` : '';
  const paramTo = to_date !== undefined ? `to_date=${to_date}` : '';
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirections = directions ? `directions=${directions}` : '';
  const paramHubs = hubs ? `hubs=${hubs}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramPostpone = postpone ? `postpone=${postpone}` : '';
  const paramsAll = [
    paramCollaborators,
    paramFrom,
    paramTo,
    paramActivityTypes,
    paramDirections,
    paramHubs,
    paramSkills,
    paramFunctions,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,
    paramPostpone
  ].join('&');
  const URL = `${ENDPOINT_PLANIFICATION}/totals${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint planification
 * Récupère les
 * @param param0
 */
const getByCollaborators = async ({
  accessToken,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - getPlanificationByCollaboratorsResponse - ...'));
  const options = getFetchGETOptions({accessToken});
  const paramFrom = from_date !== undefined ? `from_date=${from_date}` : '';
  const paramTo = to_date !== undefined ? `to_date=${to_date}` : '';
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirections = directions ? `directions=${directions}` : '';
  const paramHubs = hubs ? `hubs=${hubs}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramPostpone = postpone ? `postpone=${postpone}` : '';
  const paramsAll = [
    paramCollaborators,paramFrom,paramTo,paramActivityTypes,
    paramDirections,paramHubs,paramSkills,paramFunctions,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,paramPostpone
  ].join('&');
  const URL = `${ENDPOINT_PLANIFICATION}/collaborators${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint planification
 * Récupère les
 * @param param0
 */
const getByCustomers = async ({
  accessToken,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - getPlanificationByCustomersResponse - ...'));
  const options = getFetchGETOptions({accessToken});
  const paramFrom = from_date !== undefined ? `from_date=${from_date}` : '';
  const paramTo = to_date !== undefined ? `to_date=${to_date}` : '';
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirections = directions ? `directions=${directions}` : '';
  const paramHubs = hubs ? `hubs=${hubs}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramPostpone = postpone ? `postpone=${postpone}` : '';
  const paramsAll = [
    paramCollaborators,paramFrom,paramTo,paramActivityTypes,
    paramDirections,paramHubs,paramSkills,paramFunctions,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,paramPostpone].join('&');
  const URL = `${ENDPOINT_PLANIFICATION}/clients${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};


/**
 * Requete le endpoint planification
 * Récupère les
 * @param param0
 */
const getByActivityTypes = async ({
  accessToken,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - getPlanificationByActivityTypesResponse - ...'));
  const options = getFetchGETOptions({accessToken});
  const paramFrom = from_date !== undefined ? `from_date=${from_date}` : '';
  const paramTo = to_date !== undefined ? `to_date=${to_date}` : '';
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirections = directions ? `directions=${directions}` : '';
  const paramHubs = hubs ? `hubs=${hubs}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramPostpone = postpone ? `postpone=${postpone}` : '';
  const paramsAll = [
    paramCollaborators,paramFrom,paramTo,paramActivityTypes,
    paramDirections,paramHubs,paramSkills,paramFunctions,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,paramPostpone].join('&');
  const URL = `${ENDPOINT_PLANIFICATION}/activity_types${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};


/**
 * Requete le endpoint planification
 * Récupère les
 * @param param0
 */
const getBySkills = async ({
  accessToken,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - getPlanificationBySkillsResponse - ...'));
  const options = getFetchGETOptions({accessToken});
  const paramFrom = from_date !== undefined ? `from_date=${from_date}` : '';
  const paramTo = to_date !== undefined ? `to_date=${to_date}` : '';
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirections = directions ? `directions=${directions}` : '';
  const paramHubs = hubs ? `hubs=${hubs}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramPostpone = postpone ? `postpone=${postpone}` : '';
  const paramsAll = [
    paramCollaborators,paramFrom,paramTo,paramActivityTypes,
    paramDirections,paramHubs,paramSkills,paramFunctions,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,paramPostpone].join('&');
  const URL = `${ENDPOINT_PLANIFICATION}/skills${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};


/**
 * Requete le endpoint planification
 * Récupère les
 * @param param0
 */
const getByFunctions = async ({
  accessToken,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - getPlanificationByFunctionsResponse - ...'));
  const options = getFetchGETOptions({accessToken});
  const paramFrom = from_date !== undefined ? `from_date=${from_date}` : '';
  const paramTo = to_date !== undefined ? `to_date=${to_date}` : '';
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirections = directions ? `directions=${directions}` : '';
  const paramHubs = hubs ? `hubs=${hubs}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramPostpone = postpone ? `postpone=${postpone}` : '';
  const paramsAll = [
    paramCollaborators,paramFrom,paramTo,paramActivityTypes,
    paramDirections,paramHubs,paramSkills,paramFunctions,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,paramPostpone].join('&');
  const URL = `${ENDPOINT_PLANIFICATION}/functions${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint planification
 * Récupère les
 * @param param0
 */
const getByOrganisations = async ({
  accessToken,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - getPlanificationByOrganisationsResponse - ...'));
  const options = getFetchGETOptions({accessToken});
  const paramFrom = from_date !== undefined ? `from_date=${from_date}` : '';
  const paramTo = to_date !== undefined ? `to_date=${to_date}` : '';
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirections = directions ? `directions=${directions}` : '';
  const paramHubs = hubs ? `hubs=${hubs}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramPostpone = postpone ? `postpone=${postpone}` : '';
  const paramsAll = [
    paramCollaborators,paramFrom,paramTo,paramActivityTypes,
    paramDirections,paramHubs,paramSkills,paramFunctions,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,paramPostpone].join('&');
  const URL = `${ENDPOINT_PLANIFICATION}/hubs${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};

const planificationEndpoints = {
  getTotals,
  getByCollaborators,
  getByCustomers,
  getByActivityTypes,
  getBySkills,
  getByFunctions,
  getByOrganisations,
};

export default planificationEndpoints;
